// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "groupfolders-" + chunkId + ".js?v=" + {"vendors-node_modules_vue-material-design-icons_Cancel_vue-node_modules_vue-material-design-ic-7c522f":"54ca1f44def4803bf495","sharing":"49496caf4febb8fbf66e"}[chunkId] + "";
};